// extracted by mini-css-extract-plugin
module.exports = {"section":"CEu_section__22w9l"};